/*
Copyright (c) 2021
*/

import constants from "../../constants";

const {REQUEST_OTP, OTP_RECEIVED} = constants.OtpConstants;

export default{
    REQUEST_OTP, 
    OTP_RECEIVED,
 
    Requestotp: payload => ({
        type: REQUEST_OTP,
        payload       
    } 
    ),
    
    
    otpRecieved: () => ({
        type: OTP_RECEIVED,
    }),
}